import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useVersion } from "./VersionContext";

// Läuft nur in der Ansicht „Nebeneinander“ (?embed=1): meldet Seitenwechsel und Scrollen an die
// umgebende Ansicht und folgt deren Anweisungen. So bleiben beide Versionen auf derselben Seite.
const EmbedBridge = () => {
    const { embed, setRounded } = useVersion();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const quiet = useRef(0);

    useEffect(() => {
        if (!embed) return;
        window.parent.postMessage({ src: "parto-embed", type: "nav", path: pathname }, "*");
    }, [embed, pathname]);

    useEffect(() => {
        if (!embed) return undefined;
        let raf = 0;
        const onScroll = () => {
            if (performance.now() < quiet.current) return;
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                const max = document.documentElement.scrollHeight - window.innerHeight;
                window.parent.postMessage({ src: "parto-embed", type: "scroll", ratio: max > 0 ? window.scrollY / max : 0 }, "*");
            });
        };
        const onMessage = (e) => {
            const d = e.data;
            if (!d || d.src !== "parto-host" || e.source !== window.parent) return;
            if (d.type === "go" && typeof d.path === "string") navigate(d.path);
            if (d.type === "scroll" && typeof d.ratio === "number") {
                quiet.current = performance.now() + 180;
                const max = document.documentElement.scrollHeight - window.innerHeight;
                window.scrollTo({ top: d.ratio * max, behavior: "instant" });
            }
            if (d.type === "rounded") setRounded(!!d.on);
        };
        const onKey = (e) => e.key === "Escape" && window.parent.postMessage({ src: "parto-embed", type: "esc" }, "*");
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("message", onMessage);
        window.addEventListener("keydown", onKey);
        return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("message", onMessage); window.removeEventListener("keydown", onKey); cancelAnimationFrame(raf); };
    }, [embed, navigate, setRounded]);

    return null;
};

export default EmbedBridge;
